module.exports = __webpack_public_path__ + "img/metodos-de-pago_2.f298f6b1.svg";